import { render, staticRenderFns } from "./PopupBase.vue?vue&type=template&id=c4995a96&"
import script from "./PopupBase.vue?vue&type=script&lang=js&"
export * from "./PopupBase.vue?vue&type=script&lang=js&"
import style0 from "./PopupBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports